import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { MarkEmailUnreadOutlined, ArrowForward, ManageAccountsOutlined } from '@mui/icons-material';
import { MAIL_COLORS } from '../constants';

interface MailAuthRequiredProps {
  onNavigateToProfile: () => void;
}

export const MailAuthRequired: React.FC<MailAuthRequiredProps> = ({ onNavigateToProfile }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '65vh',
        p: 3
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 540,
          width: '100%',
          p: { xs: 3.5, sm: 5 },
          borderRadius: '24px',
          border: `1px solid ${MAIL_COLORS.borderLight}`,
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2.5
        }}
      >
        {/* Большая иконка с акцентным фоном */}
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '20px',
            bgcolor: '#eff8ff',
            border: '1px solid #bfdbfe',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: MAIL_COLORS.primary,
            mb: 0.5
          }}
        >
          <MarkEmailUnreadOutlined sx={{ fontSize: 38 }} />
        </Box>

        {/* Заголовок */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: MAIL_COLORS.textPrimary,
              letterSpacing: '-0.02em',
              mb: 1
            }}
          >
            Корпоративная почта не настроена
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: MAIL_COLORS.textSecondary,
              lineHeight: 1.6,
              fontSize: '0.95rem'
            }}
          >
            Для просмотра и отправки писем необходимо внести учетные данные корпоративной почты (логин и пароль) в вашем профиле пользователя.
          </Typography>
        </Box>

        {/* Подсказка */}
        <Box
          sx={{
            p: 2,
            borderRadius: '14px',
            bgcolor: '#f8fafc',
            border: '1px solid #e2e8f0',
            width: '100%',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5
          }}
        >
          <ManageAccountsOutlined sx={{ color: '#64748b', fontSize: 20, mt: 0.2, flexShrink: 0 }} />
          <Typography variant="body2" sx={{ color: '#475569', fontSize: '0.85rem' }}>
            После сохранения данных в разделе «Корпоративная почта» вход будет выполняться автоматически при каждом открытии почты.
          </Typography>
        </Box>

        {/* Кнопка перехода в профиль */}
        <Button
          variant="contained"
          size="large"
          onClick={onNavigateToProfile}
          endIcon={<ArrowForward />}
          sx={{
            bgcolor: MAIL_COLORS.primary,
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.95rem',
            px: 4,
            py: 1.25,
            boxShadow: '0 4px 14px rgba(21, 112, 239, 0.3)',
            '&:hover': {
              bgcolor: MAIL_COLORS.primaryHover,
              boxShadow: '0 6px 20px rgba(21, 112, 239, 0.4)'
            }
          }}
        >
          Перейти в профиль
        </Button>
      </Paper>
    </Box>
  );
};

export default MailAuthRequired;
